// Loads the AdSense script dynamically instead of via a static <script> tag in index.html, so it
// can be skipped entirely for premium users - including Google's own Auto/Anchor ads, which are
// injected by this script based on account-level config and have no concept of DN's premium
// status, unlike the two AdContainer slots which already check isPremium() themselves.
let adsScriptLoaded = false;

export function loadAdsScript() {
  if (adsScriptLoaded) {
    return;
  }
  adsScriptLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
  document.head.appendChild(script);
}

export function isAdsScriptLoaded() {
  return adsScriptLoaded;
}
